// Shared month navigator (prev / label / next) with a pay-cycle progress bar
// under the label, showing how far through the current pay month we are. Reuses
// the shared getPayCycleProgress so it can't drift from the backend's cycle.
import { h } from '../core/dom';
import { formatMonth, getPayCycleProgress } from '@lib/month';

export function monthNav(month: string, onChange: (offset: number) => void): HTMLElement {
	const p = getPayCycleProgress(month);
	const title = p.isCurrent
		? `Day ${p.dayNumber} of ${p.totalDays} [${p.percent}% complete] (${p.daysRemaining} days remaining)`
		: p.isPast
			? 'Completed'
			: `Starts in ${p.daysUntilStart} days`;
	const bar = h(
		'div',
		{
			class: `cycle-progress${p.isPast ? ' past' : ''}${p.isFuture ? ' future' : ''}`,
			title,
			role: 'progressbar',
			'aria-label': 'Pay cycle progress',
			'aria-valuemin': '0',
			'aria-valuemax': '100',
			'aria-valuenow': String(p.percent),
		},
		h('div', { class: 'cycle-progress-fill', style: { width: `${p.percent}%` } })
	);
	return h(
		'div',
		{ class: 'month-nav row' },
		h('button', { class: 'btn btn-sm', onclick: () => onChange(-1), 'aria-label': 'Previous month' }, '←'),
		h('div', { class: 'month-display' }, h('strong', {}, formatMonth(month)), bar),
		h('button', { class: 'btn btn-sm', onclick: () => onChange(1), 'aria-label': 'Next month' }, '→')
	);
}
